// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"4c66b63b","703":"b9f1c69a","787":"a4a2d5a4"}[chunkId] + ".chunk.js";
};